<template>
  <div>
    <h3>Call Takers</h3>
    <div v-if="callTakerStore.callTakers">
      <a href="#" @click="callTakerStore.preformCleanAll">Preform Clean All</a>
      <table style="width:500px">
        <tr>
          <th style="width:150px">State</th>
          <th>Name</th>
          <th style="width:100px">Incoming Call</th>
          <th>Contact</th>
          <th>Alt Contact</th>
          <th></th>
        </tr>

        <tr v-for="callTaker in callTakerStore.sortedCallTakers" :key="callTaker.sid">
          <td>
            
            <!-- <transition name="data" mode="out-in"> -->
              <!-- <span :key="callTaker.activityName"> -->
                {{callTaker.activityName}}
              <!-- </span> -->
            <!-- </transition> -->
            
            <span v-if="callTakerStore.metaCallTakers[callTaker.sid].showStateOptions">
              <span @click="$set(callTakerStore.metaCallTakers[callTaker.sid], 'showStateOptions', false)">⚙️⌃</span>
              <button @click="callTakerStore.preformCallTakerReverseState(callTaker)">Set To {{callTakerStore.callTakerReverseState(callTaker)}}</button>
            </span>
            
            <span v-else>
              <span @click="$set(callTakerStore.metaCallTakers[callTaker.sid], 'showStateOptions', true)">⚙️⌄</span>
            </span>

          </td>
            
          <td>
            <a :href="`https://www.twilio.com/console/taskrouter/workspaces/${callTaker.workspaceSid}/workers/${callTaker.sid}`" target="_blank">
              {{callTaker.friendlyName}}
            </a>↗︎
          </td>
          <td>
            <transition name="data" mode="out-in">
              <div :key="callTaker.attributes.incoming_call">
                {{$util.formatPhoneNumber(callTaker.attributes.incoming_call)}}
              </div>
            </transition>
          </td>
          <td>
            <span v-if="callTakerStore.metaCallTakers[callTaker.sid].showFullContact">
              {{callTaker.attributes.contact_uri}}
            </span>
            <span v-else>
              {{$util.formatPhoneNumber(callTaker.attributes.contact_uri)}}
            </span>
            
            <span v-if="callTakerStore.metaCallTakers[callTaker.sid].showContactOptions">
              <span @click="$set(callTakerStore.metaCallTakers[callTaker.sid], 'showContactOptions', false)">⚙️⌃</span>
              
              <button @click="callTakerStore.preformCallTakerContactSwitch(callTaker)">Switch To Alt Contact</button>
              
              <button @click="$set(callTakerStore.metaCallTakers[callTaker.sid], 'showFullContact', !callTakerStore.metaCallTakers[callTaker.sid].showFullContact);$set(callTakerStore.metaCallTakers[callTaker.sid], 'showContactOptions', false)">
                {{callTakerStore.metaCallTakers[callTaker.sid].showFullContact ? 'Hide' : 'Show'}} Full Contact
              </button>
            </span>
            
            <span v-else>
              <span @click="$set(callTakerStore.metaCallTakers[callTaker.sid], 'showContactOptions', true)">⚙️⌄</span>
            </span>

          </td>
          <td>
              {{$util.formatPhoneNumber(callTaker.attributes.alt_contact_uri)}}
            </td>
        </tr>
      </table>
      <!-- <BasicTableComponent :list="sortedCallTakers" /> -->
    </div>
    <div v-else>...Loading</div>
  </div>
</template>

<script>
export default {
  inject: ['phonePage'],
  data () { return {
  }},
  methods: {
  },

  computed: {
    callTakerStore(){
      return this.phonePage.$refs.callTakerStore;
    },
  }
}
</script>

<style scoped>
.data-enter-active {
  transition: all 1.5s ease;
}
.data-enter {
  background:rgb(188, 232, 188);
}
</style>